import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "@faire/web--source/common/consts/ISO_TO_COUNTRY_NAME";
import { THREE_LETTER_EUROPE_COUNTRY_CODES } from "@faire/web--source/common/consts/THREE_LETTER_EUROPE_COUNTRY_CODES";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { IOption } from "@faire/web--source/slate/Dropdown";

import { getSettingBrandAdditionalSupportedGeographies } from "@faire/retailer/settings/getSettingBrandAdditionalSupportedGeographies";
import { getSettingSupportedCountries } from "@faire/retailer/settings/getSettingSupportedCountries";

const getAutoAcceptedCountries = () => {
  let autoAcceptedCountries: string[] = [];

  const brandAdditionalSupportedGeographies =
    getSettingBrandAdditionalSupportedGeographies();

  brandAdditionalSupportedGeographies.forEach((geo) => {
    if (geo.country) {
      autoAcceptedCountries.push(geo.country);
    }
    if (geo.country_group && geo.country_group === "EUROPE") {
      autoAcceptedCountries = autoAcceptedCountries.concat(
        Object.values(THREE_LETTER_EUROPE_COUNTRY_CODES)
      );
    }
  });

  const union = require("arr-union");
  return union(autoAcceptedCountries, getSettingSupportedCountries()).sort();
};

export const getBrandSignupAutoAcceptedThreeLetterCodes = () =>
  getAutoAcceptedCountries();

export const getBrandSignupAutoAcceptedCountriesOptions = (
  strictLocalize: StrictLocalizeFunction
): IOption[] => [
  ...getBrandSignupAutoAcceptedThreeLetterCodes()
    .map((code: string) => {
      return {
        // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
        label: ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize)[code],
        value: code,
      };
    })
    .sort((a: IOption, b: IOption) => {
      if (a.label > b.label) {
        return 1;
      } else if (a.label < b.label) {
        return -1;
      } else {
        return 0;
      }
    }),
  {
    label: strictLocalize({
      defaultMessage: "Other",
      description: {
        text: "abbreviation for other the term 'other countries'",
      },
    }),
    value: "Other",
  },
];
